// İçe aktarma önerileri hesaplama rolü (TODO-KPI-121): shared `isCalculationGroupCandidate`
// üzerinde TEK kural. kpi-import-breakdown.ts (≤600 satır) buradan okur ve yeniden dışa aktarır.

import { isCalculationGroupCandidate, type KpiBreakdown } from "@mahir/shared";

type Rollup = KpiBreakdown["rollup"];
export type BreakdownRole = "calculation" | "check" | "none";

/** `calcRoleFor` girdi satırı: sıralı öneri (aynı üstteki öneriler listede sırayla gelir). */
export interface CalcRoleRow {
  key: string;
  parentCode: string;
  dimension: string;
  complete: boolean;
  rollup: Rollup;
}

/**
 * TODO-KPI-121 — hesap rolü TEK kuralla, kabul edilmiş + önerilen kümeden: aynı üstte aday
 * (tam ∧ toplama≠yok) öneriler arasında `accepted` (atlanmamış) olan İLK satır "calc", sonrakiler
 * "verify" (doğrulama); aday olmayan "none". Atlanan aday kümeye girmez ama kendi rolü gösterilir
 * (kendinden önce hesap grubu varsa "verify", yoksa "calc"). `externalCalc`: setteki başka bir aday
 * grup üstteki hesap grubunu zaten taşıyor → o üstün adayları "verify". Böylece iki öneri aynı anda
 * "calc" olamaz; kullanıcı ilkini atlayınca ikincisi "calc"e yükselir.
 */
export function calcRoleFor(
  rows: readonly CalcRoleRow[],
  accepted: ReadonlySet<string>,
  externalCalc: ReadonlySet<string> = new Set(),
): Map<string, "calc" | "verify" | "none"> {
  const taken = new Set(externalCalc);
  const out = new Map<string, "calc" | "verify" | "none">();
  for (const r of rows) {
    const candidate = isCalculationGroupCandidate({
      id: "",
      parentId: null,
      orderIndex: 0,
      nodeKind: "breakdown_group",
      breakdown: { dimension: r.dimension, complete: r.complete, rollup: r.rollup },
    });
    if (!candidate) {
      out.set(r.key, "none");
      continue;
    }
    out.set(r.key, taken.has(r.parentCode) ? "verify" : "calc");
    if (accepted.has(r.key)) taken.add(r.parentCode);
  }
  return out;
}

/**
 * Hesaplama rolü — shared `isCalculationGroupCandidate` / `isVerificationGroup`: aday grup, üstte
 * başka hesap grubu yoksa (`calcTaken` — setteki aday grup ya da sırada önceki aday öneri) hesap
 * grubu, varsa doğrulama; aday olmayan (tam değil ya da `none`) grup yalnız gösterim (I1).
 */
export function breakdownRole(
  dimension: string,
  complete: boolean,
  rollup: Rollup,
  calcTaken = false,
): BreakdownRole {
  if (
    isCalculationGroupCandidate({
      id: "",
      parentId: null,
      orderIndex: 0,
      nodeKind: "breakdown_group",
      breakdown: { dimension, complete, rollup },
    })
  )
    return calcTaken ? "check" : "calculation";
  return "none";
}
